import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TableCell } from '@nagel-types';
import { MapToTextPipe } from '../../table-cell-pipe';

@Component({
    selector: 'app-mapped-text-cell',
    imports: [MapToTextPipe],
    templateUrl: './mapped-text-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MappedTextCellComponent {
    cell = input.required<TableCell>();
}
